@if (areUserRolesReady) {
  <div>
    <p-menubar [model]="items">
      @if (showOnlyDesktop) {
        <ng-template #start>
          <div class="mercury-top-logo">
            <img
              routerLink="/shipping/ship"
              [src]="mercuryLogoPath"
              alt="Mercury Logo"
            />
          </div>
        </ng-template>
      }
      @if (!showOnlyDesktop) {
        <ng-template #end>
          <div class="mercury-top-logo">
            <img
              routerLink="/shipping/ship"
              [src]="mercuryLogoPath"
              alt="Mercury Logo"
            />
          </div>
        </ng-template>
      }
    </p-menubar>
  </div>
}
